import PropTypes from 'prop-types'
import { Banner } from '@artprov/design-system'
import { TEXTOS } from '../constants/textos.js'

/**
 * Banda a ancho completo con la cuenta con la que el usuario está logueado
 * (criterio 3). No se renderiza cuando todavía no hay cuenta seleccionada:
 * ese es el otro estado de la pantalla.
 */
export default function BandaCuentaConectada({ razonSocial }) {
  if (!razonSocial) return null

  // Se usa el componente Banner del design system en su variante "info".
  // El contenido se pasa por la prop `text` (el Banner no renderiza children)
  // y sin `startIcon` para que no se muestre el ícono.
  return (
    <Banner
      feedback="info"
      className="w-full"
      text={
        <>
          {TEXTOS.CUENTA_CONECTADA_PREFIJO} <span className="font-semibold">{razonSocial}</span>
        </>
      }
    />
  )
}

BandaCuentaConectada.propTypes = {
  razonSocial: PropTypes.string,
}
